/**
 * Prefer the shopper's current vehicle for "More for this vehicle".
 * Reads localStorage key "vf:vehicle" (same as vehicle-filter.js) and document.referrer.
 * Switches among pre-rendered candidate panels in sections/product-recommendations.liquid.
 */
(function () {
  'use strict';
  var STORAGE_KEY = 'vf:vehicle';

  function readSaved() {
    try {
      var v = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      return v && v.h ? v : null;
    } catch (e) {
      return null;
    }
  }

  function preferHandle(candidates) {
    var saved = readSaved();
    if (saved && saved.h) {
      for (var i = 0; i < candidates.length; i++) {
        if (candidates[i].h === saved.h) return saved.h;
      }
    }
    var ref = document.referrer || '';
    if (!ref) return null;
    try {
      var path = new URL(ref, location.origin).pathname || '';
      for (var j = 0; j < candidates.length; j++) {
        var h = candidates[j].h;
        if (path === '/collections/' + h || path.indexOf('/collections/' + h + '/') === 0) {
          return h;
        }
      }
    } catch (e2) {}
    return null;
  }

  function activate(section, handle) {
    if (!handle) return;
    var panels = section.querySelectorAll('[data-related-candidate]');
    var matched = false;
    for (var i = 0; i < panels.length; i++) {
      var on = panels[i].getAttribute('data-related-candidate') === handle;
      panels[i].hidden = !on;
      if (on) matched = true;
    }
    if (!matched) return;
    section.setAttribute('data-related-vehicle', handle);
    var name = '';
    var candidates;
    try {
      candidates = JSON.parse(section.getAttribute('data-related-candidates') || '[]');
    } catch (e) {
      candidates = [];
    }
    for (var k = 0; k < candidates.length; k++) {
      if (candidates[k].h === handle) {
        name = candidates[k].n || '';
        break;
      }
    }
    var sub = section.querySelector('[data-related-subtitle]');
    if (sub && name) sub.textContent = name;
  }

  function run() {
    var section = document.querySelector('.section--related-products[data-related-candidates]');
    if (!section) return;
    var candidates;
    try {
      candidates = JSON.parse(section.getAttribute('data-related-candidates') || '[]');
    } catch (e) {
      return;
    }
    if (!candidates || candidates.length < 2) return;
    var preferred = preferHandle(candidates);
    var current = section.getAttribute('data-related-vehicle') || '';
    if (preferred && preferred !== current) activate(section, preferred);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('vehicle-filter:change', function () {
    run();
  });
})();
